import { createContext, Dispatch, SetStateAction } from 'react';
import IProductVariantList from '../model/IProductVariantList';

interface IProductVariantsContext {
  variants: IProductVariantList;
  setVariants?: Dispatch<SetStateAction<IProductVariantList>>;
}

const ProductVariantsContext = createContext<IProductVariantsContext | null>(null);

export default ProductVariantsContext;
